import { Form } from "./types";

const mockData: Form = {
  businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpForm|d54bd969-7b3b-48ec-a6c0-e6f09db47eb5,1',
  id: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
  version: 1,
  type: 1,
  isPrivate: false,
  name: 'Form Name Text',
  description: `Welcome to our survey! We appreciate your participation as it helps us to improve our services and offerings. Please read each question carefully and provide as much detail as possible in your responses.

  The questionnaire consists of multiple sections, and you will find questions that require you to select options, input text, or even upload files as needed. Each section is important, and we encourage you not to skip any parts of the survey.
  
  
  
  `,
  tenantId: 'bd8fabbf-5289-4d33-9753-b9546ca7154f',
  clusterId: 5,
  styleOverrides: {
    background: {
      backgroundColor: 'light-blue',
    },
    headerBackgroundColor: '#22gggg',
    helperText: {
      variant: 'caption-text',
      //fontFamily: '--font-override-arial',
    },
    questionText: {
      variant: 'h3',
      //fontFamily: '--font-override-comic',
    },
    titleText: {
      //variant: 'h2',
      fontFamily: 'Arial',
    },
    paragraphText: {
      variant: 'data-display-three',
      fontFamily: 'Arial',
    }
  },
  formQuestions: [
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|af782dfd-d01a-4e18-b979-1aaad8a57443',
      id: 'af782dfd-d01a-4e18-b979-1aaad8a57443',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'HiddenQuestion',
      questionText: '',
      fieldTypeId: 1,
      fieldProperties: null,
      clusterId: 2,
      helperText: null,
      section: 1,
      questionOrder: 1,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|b8e4259d-2062-4524-8b38-2746c302d908',
      id: 'b8e4259d-2062-4524-8b38-2746c302d908',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'SingleLineTextQuestion',
      questionText: 'Question using a Single Line input',
      fieldTypeId: 2,
      fieldProperties: {
        maxCharacter: 64,
        minCharacter: 0,
      },
      // defaultValue: 'test-value',
      clusterId: 3,
      helperText: 'Helper Text For SingleLineTextQuestion',
      section: 1,
      questionOrder: 2,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|8fec36b7-dd27-477b-bfb4-b58a4693d7e4',
      id: '8fec36b7-dd27-477b-bfb4-b58a4693d7e4',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'MultiLineTextQuestion',
      questionText: 'Question using a Multi-Line Text input',
      fieldTypeId: 3,
      fieldProperties: {
        maxCharacter: 256,
        minCharacter: 10,
      },
      // defaultValue: 'kjhsa;lfkhjasl;kfj',
      clusterId: 4,
      helperText: null,
      section: 1,
      questionOrder: 3,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|6f4146cf-90ea-44c6-bd81-20fcf5ffd582',
      id: '6f4146cf-90ea-44c6-bd81-20fcf5ffd582',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'CheckboxQuestion',
      questionText: 'Question using 1 or more Checkbox inputs',
      fieldTypeId: 4,
      fieldProperties: {
        items: [
          {
            display: 'item 1',
            value: 'value 1',
          },
          {
            display: 'item 2',
            value: 'value 2',
          },
          {
            display: 'item 3',
            value: 'value 3',
          },
          {
            display: 'item 4',
            value: 'value 4',
          },
        ],
      },
      clusterId: 5,
      helperText: null,
      section: 1,
      questionOrder: 4,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|aa935a31-c14c-4624-b45e-b4f933f38f55',
      id: 'aa935a31-c14c-4624-b45e-b4f933f38f55',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'RadioButtonQuestion',
      questionText: 'Question using 2 or more Radio Button inputs',
      fieldTypeId: 5,
      fieldProperties: {
        items: [
          {
            display: 'item 1',
            value: 'value 1',
          },
          {
            display: 'item 2',
            value: 'value 2',
          },
          {
            display: 'item 3',
            value: 'value 3',
          },
        ],
      },
      clusterId: 6,
      helperText: 'Helper Text For RadioButtonQuestion',
      section: 1,
      questionOrder: 5,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|5d3ba4b4-27bd-4315-9f97-0ef32080adaa',
      id: '5d3ba4b4-27bd-4315-9f97-0ef32080adaa',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'DropdownSingleSelectQuestion',
      questionText: 'Question using a Dropdown Input with single selection',
      fieldTypeId: 6,
      fieldProperties: {
        items: [
          {
            display: 'Age range?',
            value: 'age_range',
          },
          {
            display: 'Employment status?',
            value: 'employment_status',
          },
          {
            display: 'Highest education completed?',
            value: 'education_level',
          },
          {
            display: 'Marital status?',
            value: 'marital_status',
          },
          {
            display: 'Annual income range?',
            value: 'income_range',
          },
          {
            display: 'Residence type?',
            value: 'residence_type',
          },
          {
            display: 'Do you have children?',
            value: 'has_children',
          },
          {
            display: 'Own or rent?',
            value: 'housing_status',
          },
          {
            display: 'Primary mode of transportation?',
            value: 'transport_mode',
          },
          {
            display: 'Do you have pets?',
            value: 'has_pets',
          },
          {
            display: 'Current health status?',
            value: 'health_status',
          },
          {
            display: 'Do you exercise regularly?',
            value: 'exercise_frequency',
          },
        ],
      },
      clusterId: 7,
      helperText: null,
      section: 2,
      questionOrder: 6,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|bb6771b2-8228-4600-80e9-18686e509b26',
      id: 'bb6771b2-8228-4600-80e9-18686e509b26',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'DropdownMultipleSelectQuestion',
      questionText: 'Question using a Dropdown Input with multiple selections',
      fieldTypeId: 7,
      fieldProperties: {
        items: [
          {
            display: 'item 1',
            value: 'value 1',
          },
          {
            display: 'item 2',
            value: 'value 2',
          },
          {
            display: 'item 3',
            value: 'value 3',
          },
        ],
      },
      clusterId: 9,
      helperText: null,
      section: 2,
      questionOrder: 7,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|1ef9e1d9-e241-448a-9320-e913a9de5dbf',
      id: '1ef9e1d9-e241-448a-9320-e913a9de5dbf',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'ListQuestion',
      questionText: 'Question using a List Input with multiple selections',
      fieldTypeId: 8,
      fieldProperties: {
        items: [
          {
            display: 'item 1',
            value: 'value 1',
          },
          {
            display: 'item 2',
            value: 'value 2',
          },
          {
            display: 'item 3',
            value: 'value 3',
          },
        ],
      },
      clusterId: 10,
      helperText: null,
      section: 2,
      questionOrder: 8,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|b629b74e-31a7-4a56-915f-dfb6796443ef',
      id: 'b629b74e-31a7-4a56-915f-dfb6796443ef',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'DateSelectorQuestion',
      questionText: 'Question using a Date Selector Input',
      fieldTypeId: 9,
      fieldProperties: {
        allowFutureDate: false,
        maxDate: '2020/12/31',
        minDate: '1980/01/01',
      },
      clusterId: 11,
      helperText: null,
      section: 2,
      questionOrder: 9,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|1875041c-0868-4daf-a402-efe478f935ab',
      id: '1875041c-0868-4daf-a402-efe478f935ab',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'TimeSelectorQuestion',
      questionText: 'Question using a Time Selector Input',
      fieldTypeId: 10,
      fieldProperties: {
        maxTime: '17:00:00',
        minTime: '09:00:00',
      },
      clusterId: 12,
      helperText: null,
      section: 3,
      questionOrder: 10,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|0d480314-0161-45ba-ab06-cc17fdad4e3b',
      id: '0d480314-0161-45ba-ab06-cc17fdad4e3b',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'DateTimeSelectorQuestion',
      questionText: 'Question using a DateTime Selector Input',
      fieldTypeId: 11,
      fieldProperties: {
        allowFutureDate: false,
        maxDateTime: '2020/12/31 23:59:59',
        minDateTime: '1980/01/01 00:00:00',
      },
      clusterId: 13,
      helperText: null,
      section: 3,
      questionOrder: 11,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|a11e9d54-d0fe-4c95-9219-466adf4875df',
      id: 'a11e9d54-d0fe-4c95-9219-466adf4875df',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'FileUploadQuestion',
      questionText: 'Question using a File Upload Input',
      fieldTypeId: 12,
      fieldProperties: {
        hideDragAndDrop: true,
        hideButton: false,
      },
      clusterId: 14,
      helperText: 'Helper Text For FileUploadQuestion',
      section: 3,
      questionOrder: 12,
      required: true,
      form: null,
    },
    {
      businessObjectKey: 'Univerus.Unity.RnDFelbel.Project.Models.UdpFormQuestion|b8e4259d-2062-4524-8b38-2746c302d909',
      id: 'b8e4259d-2062-4524-8b38-2746c302d909',
      formId: 'd54bd969-7b3b-48ec-a6c0-e6f09db47eb5',
      formVersion: 1,
      name: 'Description',
      questionText: '',
      fieldTypeId: 13,
      fieldProperties: {},
      clusterId: 3,
      helperText: '',
      section: 1,
      questionOrder: 1,
      required: true,
      form: null,
    },
  ],
};

export default mockData;
